

exports.__esModule = true;
exports.$xoSidebarAddShippingPageComponent = undefined;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-page-components/src/aside-header/directive');

require('xo-validation/dist/directive');

require('xo-member-components/src/select-shipping/directive');

require('xo-ui-components/src/dropdown/directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddShippingPageComponent = exports.$xoSidebarAddShippingPageComponent = _squid.$Component.extend('$xoSidebarAddShippingPageComponent', {
    tag: 'xo-sidebar-add-shipping-page',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, $state) {
        $scope.token = $rootScope.token;
        $scope.sidebar = true;

        $scope.onComplete = function () {
            $state.go('checkout.review');
        };
    }
});

angular.value("$xoSidebarAddShippingPageComponent", $xoSidebarAddShippingPageComponent);
_squid.$Component;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-add-shipping/directive.js
// module id = ./pages/xo-sidebar-add-shipping/directive.js
// module chunks = 1